import { AppConfigModel } from '../abstract/app-config.model';

export class MfaPolicy extends AppConfigModel {

    static override CLASS_NAME: string = 'MfaPolicy';
}
